module.exports = __webpack_public_path__ + "media/images/shopping-cart/paypal-b2aec19cf5a945720fa434c25ce70805.png";